module.exports = __webpack_public_path__ + "img/atom-color.fbf39910.svg";